import { setThemeMode } from './slices/app';

export const MODES = {
  DARK: 'dark',
  LIGHT: 'light',
};

// Current theme
export const theme = { mode: MODES.LIGHT };

// Themes DOM link elements
const themes = {
  light: document.querySelector('[href*="/main.css"]'),
};

export const switchTheme = async (value, dispatch) => {
  const newMode = value ?? (theme.mode === MODES.DARK ? MODES.LIGHT : MODES.DARK);
  if (newMode === theme.mode) {
    return;
  }

  theme.mode = newMode;
  if (dispatch) {
    dispatch(setThemeMode(newMode));
  }

  if (window?.localStorage) {
    window.localStorage.setItem('theme_mode', newMode);
  }

  if (newMode === MODES.LIGHT) {
    document.head.appendChild(themes.light);
    // Remove dark.css link from DOM
    const darkStyle = document.querySelector('[href*="/dark.css"]');
    darkStyle?.remove();
  }

  if (newMode === MODES.DARK) {
    if (themes.dark) {
      document.head.appendChild(themes.dark);
      return;
    }
    import(/* webpackChunkName: "dark" */ './styles/index.scss?dark').then(() => {
      // Set Dark Styles link element
      themes.dark = document.querySelector('[href*="/dark.css"]');
    });
  }
};
